import { render, staticRenderFns } from "./invitation_approvals.vue?vue&type=template&id=51e68b27&scoped=true"
import script from "./invitation_approvals.vue?vue&type=script&lang=js"
export * from "./invitation_approvals.vue?vue&type=script&lang=js"
import style0 from "./invitation_approvals.vue?vue&type=style&index=0&id=51e68b27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e68b27",
  null
  
)

export default component.exports